import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Toaster } from 'react-hot-toast';
import { useEffect } from 'react';

import { queryClient } from './config/query-client';
import { ApiProvider } from './providers/ApiProvider';
import { CurrencyProvider } from './providers/CurrencyProvider';
import { AppRouter } from './router/AppRouter';
import { useAdminLanguageStore } from './stores/language.store';
import { resolveDocumentLanguage } from './i18n';

export function App() {
  const language = useAdminLanguageStore((state) => state.language);

  useEffect(() => {
    document.documentElement.lang = resolveDocumentLanguage(language);
  }, [language]);

  return (
    <QueryClientProvider client={queryClient}>
      <ApiProvider>
        {/* Tiền tệ hiển thị theo phạm vi đang xem (sheet 2 #75). Trang nào có
            tiền tệ riêng thì gọi `useCurrencyScope`; trang không gọi dùng mặc
            định của app. */}
        <CurrencyProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
              success: {
                duration: 3000,
                iconTheme: {
                  primary: '#22c55e',
                  secondary: '#fff',
                },
              },
              error: {
                duration: 5000,
                iconTheme: {
                  primary: '#ef4444',
                  secondary: '#fff',
                },
              },
            }}
          />
        </BrowserRouter>
        </CurrencyProvider>
      </ApiProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
